export default class BlockVideoLibrary {
    constructor() {
        if (!window.acf) {
            // Frontend only
            BlockVideoLibrary.callBlockService()
        }
    }

    static callBlockService() {
        if ($('[data-element="video-library-slider"]').length > 0) {
            import(
                '@blocks/video-library/scripts/services/VideoLibraryService' /* webpackChunkName: "scripts/services/VideoLibraryService" */
            ).then(({ default: Block }) => {
                new Block()
            })
        }
    }
}

new BlockVideoLibrary()
